export default __webpack_public_path__ + "static/media/Forgot_Password.070be119.png";